import {Col, Input, Row, Select, Space, Spin, Switch} from "antd";
import React from "react";
import {Field} from "react-final-form";
import {useCompanyData, useVehicleData} from "../../../../../../../../Hooks/TT_ELD/Companies";
import {useVehicleSearch} from "../../../../../../../../Hooks/TT_ELD/Logs";

const IdFields = ({ data }: { data: any }) => {
    const vehicleData: any = useVehicleSearch('', data?.companyId);

    return !vehicleData.isLoading ? (
        <div>
            <Space direction="vertical" size="middle" style={{display: 'flex'}}>
                <Row gutter={16}>
                    <Col span={8}>
                        <div>
                            <label>ID: </label>
                            <Field
                                name="id"
                                render={({input}: { input: any }) => (
                                    <Input disabled type="text" {...input} />
                                )}
                            />
                        </div>
                    </Col>
                    <Col span={8}>
                        <div>
                            <label>Company ID: </label>
                            <Field
                                name="companyId"
                                render={({input}: { input: any }) => (
                                    <Input type="text" {...input} />
                                )}
                            />
                        </div>
                    </Col>
                    <Col span={8}>
                        <div>
                            <label>Driver ID: </label>
                            <Field
                                name="driverId"
                                render={({input}: { input: any }) => (
                                    <Input type="text" {...input} />
                                )}
                            />
                        </div>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={8}>
                        <div>
                            <label>Vehicle ID: </label>
                            <Field
                                name="vehicleId"
                                render={({input}: { input: any }) => (
                                    <Input type="text" {...input} />
                                )}
                            />
                        </div>
                    </Col>
                    <Col span={8}>
                        <div>
                            <label>Client ID: </label>
                            <Field
                                name="client_id"
                                render={({input}: { input: any }) => (
                                    <Input type="text" {...input} />
                                )}
                            />
                        </div>
                    </Col>
                    <Col span={8}>
                        <div>
                            <label>Eld ID: </label>
                            <Field
                                name="eldId"
                                render={({input}: { input: any }) => (
                                    <Input type="text" {...input} />
                                )}
                            />
                        </div>
                    </Col>
                </Row>

                <Row gutter={16}>
                    {/*<Col span={8}>*/}
                    {/*    <div>*/}
                    {/*        <label>Origin Code: </label>*/}
                    {/*        <Field*/}
                    {/*            name="origin_code"*/}
                    {/*            render={({input}: { input: any }) => (*/}
                    {/*                <Input type="text" {...input} />*/}
                    {/*            )}*/}
                    {/*        />*/}
                    {/*    </div>*/}
                    {/*</Col>*/}

                </Row>
            </Space>
        </div>
    ) : <Spin size="large" spinning={vehicleData?.isLoading}></Spin>
};

export default IdFields;